import React, {
    useEffect,
    useRef
}
from "react";


//========================================================
// Eva Conversation
//========================================================

export default function EvaConversation({
    messages,
    thinking,
    evaImage
})
{

    //----------------------------------------------------
    // References
    //----------------------------------------------------

    const messagesEndRef =
        useRef(null);


    //----------------------------------------------------
    // Scroll To Latest Message
    //----------------------------------------------------

    useEffect(

        function()
        {

            if (messagesEndRef.current)
            {

                messagesEndRef.current.scrollIntoView({
                    behavior: "smooth"
                });

            }

        },

        [
            messages,
            thinking
        ]

    );


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (

        <div
            className="eva-chat-messages"
        >

            {
                messages.map(
                    (item, index) =>
                    (

                        <div
                            key={index}

                            className={
                                "eva-chat-message-row " +
                                (
                                    item.role === "user"
                                        ?
                                        "eva-chat-message-row-user"
                                        :
                                        "eva-chat-message-row-eva"
                                )
                            }
                        >

                            {
                                item.role === "eva" &&
                                (

                                    <img
                                        src={evaImage}
                                        className="eva-chat-message-avatar"
                                        alt=""
                                    />

                                )
                            }


                            <div
                                className={
                                    "eva-chat-message " +
                                    (
                                        item.role === "user"
                                            ?
                                            "eva-chat-message-user"
                                            :
                                            "eva-chat-message-eva"
                                    )
                                }
                            >

                                {item.text}

                            </div>

                        </div>

                    )
                )
            }


            {/*============================================
                Thinking
            ============================================*/}

            {
                thinking &&
                (

                    <div
                        className="
                            eva-chat-message-row
                            eva-chat-message-row-eva
                        "
                    >

                        <img
                            src={evaImage}
                            className="eva-chat-message-avatar"
                            alt=""
                        />


                        <div
                            className="
                                eva-chat-message
                                eva-chat-message-eva
                                eva-chat-thinking
                            "
                        >

                            <span />
                            <span />
                            <span />

                        </div>

                    </div>

                )
            }


            <div
                ref={messagesEndRef}
            />

        </div>

    );

}